/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrencyPointsRequest
 */
export interface UpdateCurrencyPointsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCurrencyPointsRequest
     */
    currencyPoints: number;
}

/**
 * Check if a given object implements the UpdateCurrencyPointsRequest interface.
 */
export function instanceOfUpdateCurrencyPointsRequest(value: object): value is UpdateCurrencyPointsRequest {
    if (!('currencyPoints' in value) || value['currencyPoints'] === undefined) return false;
    return true;
}

export function UpdateCurrencyPointsRequestFromJSON(json: any): UpdateCurrencyPointsRequest {
    return UpdateCurrencyPointsRequestFromJSONTyped(json, false);
}

export function UpdateCurrencyPointsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrencyPointsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyPoints': json['currencyPoints'],
    };
}

export function UpdateCurrencyPointsRequestToJSON(json: any): UpdateCurrencyPointsRequest {
    return UpdateCurrencyPointsRequestToJSONTyped(json, false);
}

export function UpdateCurrencyPointsRequestToJSONTyped(value?: UpdateCurrencyPointsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyPoints': value['currencyPoints'],
    };
}

